import Vue from 'vue'

const _that = new Vue();
const date = new Date();
const exportJsonToExcel = require('../vendor/Export2Excel');
export default {
  // 机构组件绑定双击事件
  toFindeCascaderEl(refName, _this) {
    setTimeout(() => {
      document.getElementsByClassName('selectCompanyEl')[0].addEventListener('dblclick', () => {
        _this.$refs[refName].handleClickoutside()
      })
    }, 0)
  },
  dateFormat(fmt, date) {
    let ret;
    const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
    };
    return fmt;
  },
  // 格式化中国标准时间 返回yyyy-mm-ss
  parseTime(str) {
    if (str) {
      if ((str + '').indexOf('-') !== -1) {
        str = str.replace(new RegExp(/-/gm), '/')
      }
      let d = new Date(str);
      let newDateYear = d.getFullYear();
      let newDateMonth = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
      let newDateDay = d.getDate() + '' < 10 ? '0' + d.getDate() + '' : d.getDate() + '';
      return newDateYear + '-' + newDateMonth + '-' + newDateDay;
    }
    return str
  },
  // 获取当前年一月一日到今天的数据
  getBeginYearToNow() {
    let arr = [];
    let data_now = this.parseTime(date);
    let begin_date = this.parseTime(new Date(date.getFullYear(), 0, 1));
    arr = [begin_date, data_now];
    return arr;
  },
  //获取当天的日期
  getCurrentDate() {
    return this.parseTime(new Date())
  },
  //获取一年的一月一号到十二月三十一号的数据
  getNewTime(year) {
    let arr = [];
    let data_now = this.parseTime(new Date(year, 11, 31));
    let begin_date = this.parseTime(new Date(year, 0, 1));
    arr = [begin_date, data_now];
    return arr;
  },

  // 获取数组最后一位
  getArrLast(arr) {
    if (this.isEmptyArray(arr)) {
      return arr[arr.length - 1]
    }
    return '';
  },
  // 导出
  exportExcel(tHeader, filterVal, tabData, excelName, loading) {
    require.ensure([], () => {
      const data = this.formatJson(filterVal, tabData);
      exportJsonToExcel.export_json_to_excel(tHeader, data, excelName);
      _that.$message.success('导出数据成功')
      loading.close();
    });
  },
  formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]))
  },
  //获取对象的所有value值
  getObjValues(obj) {
    let keysArr = Object.keys(obj)
    let length = keysArr.length
    let result = []
    for (let i = 0; i < length; i++) {
      result.push(obj[keysArr[i]])
    }
    return result
  },
  // 请求表格数据
  async requestTableData(_url, params, showModal = false, showTips = true) {
    let loading = null;
    if (showModal) {
      loading = _that.$loading({
        lock: true,
        text: "系统正在努力加载,请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    }
    const res = await _that.zzlHttp.post(_url, params, showTips);
    if (showModal) {
      loading.close();
    }
    if (res.code === 0) {
      return res.data;
    } else {
      return []
    }
  },
  async postLoading(_url, params, showModal = false, showTips = true) {
    let loading = null;
    if (showModal) {
      loading = _that.$loading({
        lock: true,
        text: "系统正在努力加载,请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    }
    const res = await _that.zzlHttp.post(_url, params, showTips);
    if (showModal) {
      loading.close();
    }
    if (res.code === 0) {
      return res
    } else {
      return []
    }
  },
  // 校验身份证
  IdentityCodeValid(value) {
    let city = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外 "
    };
    let tip = "";
    let pass = true;

    if (!value || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(value)) {
      tip = "身份证号格式错误";
      pass = false;
    } else if (!city[value.substr(0, 2)]) {
      tip = "地址编码错误";
      pass = false;
    } else {
      //18位身份证需要验证最后一位校验位
      if (value.length == 18) {
        value = value.split('');
        //加权因子
        let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //校验位
        let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
        let sum = 0;
        let ai = 0;
        let wi = 0;
        for (let i = 0; i < 17; i++) {
          ai = value[i];
          wi = factor[i];
          sum += ai * wi;
        }
        let last = parity[sum % 11];
        if (parity[sum % 11] != value[17]) {
          tip = "校验位错误";
          pass = false;
        }
      }
    }
    return pass;
  },
  // 星级识别
  recognitionStar(_num) {
    switch (_num) {
      case '0':
        return '无'
      case '1':
        return '一星'
      case '2':
        return '二星'
      case '3':
        return '三星'
      case '4':
        return '四星'
      case '5':
        return '五星'
      default:
        return _num
    }
  },
  // 根据ID获取对应名称
  getNameById(_id, _list) {
    for (let _item of _list) {
      if (_id == _item.id) {
        return _item.name
      }
    }
    return _id
  },
  // 根据value获取对应名称
  getLabelByValue(_val, _list) {
    for (let _item of _list) {
      if (_val == _item.value) {
        return _item.label
      }
    }
    return isNaN(_val) ? '无' : _val
  },
  // 根据label获取对应名称
  getLabelByLabel(_val, _list) {
    for (let _item of _list) {
      if (_val == _item.label) {
        return _item.label
      }
    }
    return isNaN(_val) ? '无' : _val
  },
  getValueByLabel(_val, _list) {
    for (let _item of _list) {
      if (_val === _item.label) {
        return _item.value
      }
    }
    return _val
  },
  // 根据value获取对应颜色
  getLabelByColor(_val, _list) {
    for (let _item of _list) {
      if (_val == _item.value) {
        return _item.color
      }
    }
    return isNaN(_val) ? '无' : _val
  },
  // 日期时间截取
  getTimeDate(_val) {
    if (!_val) {
      return _val
    }
    if (_val.indexOf('T') !== -1) {
      return _val.split('T')[0]
    } else {
      let date = _val.split(' ')[0]
      if (date.indexOf('/') !== -1) {
        let arr = date.split('/')
        arr[1] = Number(arr[1]) >= 10 ? arr[1] : '0' + arr[1]
        arr[2] = Number(arr[2]) >= 10 ? arr[2] : '0' + arr[2]
        return arr.join('-')
      } else {
        return date
      }
    }
  },
  // 日期时间截取2019/5/6
  getTimeDateOne(_val) {
    if (!_val) {
      return _val
    }
    let date = _val.split(' ')[0];
    if (date) {
      let arr = date.split('-');
      arr[1] = this.numberChange(arr[1]);
      arr[2] = this.numberChange(arr[2]);
      return arr.join('/');
    }
    return _val
  },
  numberChange(str) {
    let first = str.substr(0, 1);
    if (first < 1) {
      return str.substr(1, 2)
    }
    return str;
  },

  // 其他时间截取
  getTimeOther(_val) {
    if (!_val) {
      return _val
    }
    if (_val.split('T')[0]) {
      return _val.split('T')[0]
    }
    return _val
  },
  // 格式化金额
  moneyFormat(value) {
    if (value !== '' && !isNaN(value)) {
      if (value >= 0) {
        let num = null;
        if (
          value == null ||
          value === 0 ||
          value === undefined ||
          value === '&#160;'
        ) {
          num = '0.00'
        } else {
          let result = value.toString().indexOf('.')
          if (result !== -1) {
            if (value.toString().substring(result, value.length).length >= 3) {
              if (typeof value === 'string') {
                num = parseInt(value).toFixed(2)
              }
              num = value.toFixed(2)
            } else {
              num = value + '0'
            }
          } else {
            num = value + '.00'
          }
        }
        return num
      } else {
        return '0.00'
      }
    } else {
      return '0.00'
    }
  },
  // empty array
  isEmptyArray(arr) {
    if (Array.isArray(arr)) {
      if (!arr.length) {
        return false
      } else {
        return true
      }
    }
    return false
  },
  // 检查图片文件
  checkImg(file) {
    let isFileFormat =
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg' ||
      file.type === 'image/png';
    const isLt100K = file.size < 1024 * 1024 * 2;
    if (!isFileFormat) {
      _that.$message.error('可上传文件包括jpg、jpeg、png、pdf');
    }
    if (!isLt100K) {
      _that.$message.error('上传图片大小不能超过 2M!');
    }
    return isFileFormat && isLt100K;
  },
  // 检查图片文件
  checkImgs(file) {
    let isFileFormat =
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'application/pdf';
    const isLt100M = file.size < 104857600;
    if (!isFileFormat) {
      _that.$message.error('可上传文件包括jpg、jpeg、png、pdf');
    }
    if (!isLt100M) {
      _that.$message.error('上传文件大小不能超过 100M!');
    }
    return isFileFormat && isLt100M;
  },
  checkPDF(file) {
    let isFileFormat =
      file.type === 'application/pdf';
    const isLt10M = file.size < 10485760;
    if (!isFileFormat) {
      _that.$message.error('请上传PDF文件');
    }
    if (!isLt10M) {
      _that.$message.error('上传文件大小不能超过 10M!');
    }
    return isFileFormat && isLt10M;
  },
  // 检查文件
  checkFile(file) {
    let str = file.name.substring(file.name.lastIndexOf('.'), file.name.length)
    let isFileFormat =
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'application/vnd.ms-excel' ||
      file.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'video/mp4' ||
      file.type === 'audio/mp3' ||
      file.type === 'application/pdf' ||
      str === '.rar' ||
      str === '.7z' ||
      str === '.zip' ||
      str === '.wma' ||
      str === '.m4a' ||
      file.type ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      file.type === 'application/msword'
    const isLt100M = file.size < 1048576000
    if (!isFileFormat) {
      _that.$message.error(
        '可上传文件包括jpg、jpeg、png、mp4、mp3、excel、rar、7z、zip、doc、docx'
      )
    }
    if (!isLt100M) {
      _that.$message.error('上传文件大小不能超过 100MB!')
    }
    return isFileFormat && isLt100M
  },
  //身份证校验
  validateIdCard(idCard) {
    //15位和18位身份证号码的正则表达式
    var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

    //如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(idCard)) {
      if (idCard.length == 18) {
        var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
        var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
        var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
        for (var i = 0; i < 17; i++) {
          idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
        }

        var idCardMod = idCardWiSum % 11;//计算出校验码所在数组的位置
        var idCardLast = idCard.substring(17);//得到最后一位身份证号码

        //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
        if (idCardMod == 2) {
          if (idCardLast == "X" || idCardLast == "x") {
            return true
          } else {
            return false
          }
        } else {
          //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
          if (idCardLast == idCardY[idCardMod]) {
            return true
          } else {
            return false
          }
        }
      }
    } else {
      return false
    }
  },
  checkStatus(Array) {
    Array.map((item) => {
      item.status = item.status === 'V'
      if (item.children) {
        this.checkStatus(item.children)
      }
    })
    return Array
  },
  numberConvertToUppercase(num) {
    num = Number(num);
    var upperCaseNumber = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿'];
    var length = String(num).length;
    if (length == 1) {
      return upperCaseNumber[num];
    } else if (length == 2) {
      if (num == 10) {
        return upperCaseNumber[num];
      } else if (num > 10 && num < 20) {
        return '十' + upperCaseNumber[String(num).charAt(1)];
      } else {
        return upperCaseNumber[String(num).charAt(0)] + '十' + upperCaseNumber[String(num).charAt(1)].replace('零', '');
      }
    }
  },
  // 获取想要key值类型的数组
  getKeyArr(list, keyObj) {
    let arr = [];
    for (let item of list) {
      let obj = {};
      for (let key in keyObj) {
        obj[key] = item[keyObj[key]];
      }
      arr.push(obj);
    }
    return arr
  },
}
